import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import PrimeVue from 'primevue/config';
import QrcodeVue from 'qrcode.vue'


//theme
import "primevue/resources/themes/lara-light-indigo/theme.css";
//styles
import "primevue/resources/primevue.min.css";
//icons
import "primeicons/primeicons.css";

//PrimeVue Imports
import AutoComplete from 'primevue/autocomplete';
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import Checkbox from 'primevue/checkbox';
import Chips from 'primevue/chips';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';
import DataTable from 'primevue/datatable';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import InputNumber from 'primevue/inputnumber';
import InputText from 'primevue/inputtext';
import Message from 'primevue/message';
import MultiSelect from 'primevue/multiselect';
import Panel from 'primevue/panel';
import RadioButton from 'primevue/radiobutton';
import Row from 'primevue/row';
import SplitButton from 'primevue/splitbutton';
import Textarea from 'primevue/textarea';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';

const app = createApp(App);

app.use(router);
app.use(PrimeVue);
app.use(ToastService);

//Inyeccion de HTML Components
app.component('AutoComplete', AutoComplete);
app.component('Button', Button);
app.component('Calendar', Calendar);
app.component('Checkbox', Checkbox);
app.component('Chips', Chips);
app.component('Column', Column);
app.component('ColumnGroup', ColumnGroup);
app.component('DataTable', DataTable);
app.component('Dialog', Dialog);
app.component('Dropdown', Dropdown);
app.component('InputNumber', InputNumber);
app.component('InputText', InputText);
app.component('Message', Message);
app.component('MultiSelect', MultiSelect);
app.component('Panel', Panel);
app.component('RadioButton', RadioButton);
app.component('Row', Row);
app.component('SplitButton', SplitButton);
app.component('Textarea', Textarea);
app.component('Toast', Toast);
app.component('QrcodeVue', QrcodeVue);

app.mount('#app');
